/* eslint-disable */
import Vue from 'vue'
import RaiseImg from './index.vue'
const PopupBox = Vue.extend(RaiseImg)
let instance = null
RaiseImg.install = function (data) {
  if (data.action === 'close') {
    if (instance) {
      instance.modalShow = false
    }
    return
  }
  instance = new PopupBox({
    data
  }).$mount()
  document.body.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.modalShow = true
    // show 和弹窗组件里的show对应，用于控制显隐
  })
}
export default RaiseImg